export const getLogoData = modelInfo => {
  const {
    assetsBrand,
    brandVariant,
    isFleet,
    isFamilyFirst,
    isFamilyFirstCA,
    language,
    isCanada,
    uiPath
  } = modelInfo;

  const path = `${uiPath}/assets/images/logos/`;
  const brandsWithSvg = ['buick', 'cadillac'];

  if (isFleet && isCanada) {
    const name = language === 'fr' ? 'fleet-fr' : 'fleet';
    return {
      logoBreakpoint: 0,
      lowDpiLogoUrl: `${path}${name}.png`,
      highDpiLogoUrl: `${path}${name}-retina.png 2x`,
      lowDpiHorizontalLogoUrl: `${path}${name}.png`,
      highDpiHorizontalLogoUrl: `${path}${name}-retina.png 2x`
    };
  }

  if (isFleet) {
    return {
      logoBreakpoint: 0,
      lowDpiLogoUrl: `${path}envolve.svg`,
      highDpiLogoUrl: `${path}envolve-retina.svg`,
      lowDpiHorizontalLogoUrl: `${path}envolve.svg`,
      highDpiHorizontalLogoUrl: `${path}envolve-retina.svg`
    };
  }

  if (isFamilyFirstCA && isCanada) {
    const name = language === 'fr' ? 'ff-CA-fr' : 'ff-CA';
    const HORIZONTAL_IMAGE_WIDTHS = {
      en: 675,
      fr: 1202
    };
    const breakpoint = HORIZONTAL_IMAGE_WIDTHS[language];
    if (language === 'fr') {
      return {
        logoBreakpoint: breakpoint,
        lowDpiLogoUrl: `${path}${name}.png`,
        highDpiLogoUrl: `${path}${name}.png`,
        lowDpiHorizontalLogoUrl: `${path}${name}.png`,
        highDpiHorizontalLogoUrl: `${path}${name}.png`
      };
    }

    return {
      logoBreakpoint: breakpoint,
      lowDpiLogoUrl: `${path}${name}.png`,
      highDpiLogoUrl: `${path}${name}.png`,
      lowDpiHorizontalLogoUrl: `${path}${name}.png`,
      highDpiHorizontalLogoUrl: `${path}${name}.png`
    };
  }

  if (isFamilyFirst) {
    const url = `${path}${brandVariant}.png`;
    return {
      logoBreakpoint: 0,
      lowDpiLogoUrl: url,
      highDpiLogoUrl: url,
      lowDpiHorizontalLogoUrl: url,
      highDpiHorizontalLogoUrl: url
    };
  }

  const url = brandsWithSvg.includes(assetsBrand)
    ? `${path}${assetsBrand}.svg`
    : `${path}${assetsBrand}.png`;
  const highResUrl = brandsWithSvg.includes(assetsBrand)
    ? `${path}${assetsBrand}.svg`
    : `${path}${assetsBrand}-retina.png`;
  return {
    logoBreakpoint: 0,
    lowDpiLogoUrl: url,
    highDpiLogoUrl: `${highResUrl} 2x`,
    lowDpiHorizontalLogoUrl: url,
    highDpiHorizontalLogoUrl: `${highResUrl} 2x`
  };
};
